// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"570b064d","667":"b001970a"}[chunkId] + ".chunk.js";
};